export const L11N = {
  EN: {
    english: "English",
    turkish: "Turkish",
    dutch: "Dutch",
    german: "German",
    spanish: "Spanish",
    italian: "Italian",
    french: "French",
    portuguese: "Portuguese",
    hindi: "Hindi",
    arabic: "Arabic",
    ukrainian: "Ukrainian",
    polish: "Polish",
    submit: "Send",
    email_at: "Email",
    phone_hash: "Mobile",
    install_taalia: "Install Taalia",
    why_install: "Do more activities and track your progress.",
    default_input_placeholder: "Message Taalia",
    input_placeholder_email: "Email address",
    input_placeholder_phone: "Mobile number",
    input_placeholder_name: "Your name",
    taalia_home: "Taalia Homepage",
    about_taalia: "About Taalia",
    sign_in: "Sign-In",
    get_app: "Get App",
    do_more_with_taalia: "Do more with Taalia",
    copyright: "Copyright © 2025 Vondelbaan B.V. All rights reserved.",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service",
    cookie_policy: "Cookie Policy",
    close: "Close",
    unlock_your_free_assessment: "Unlock your first FREE assessment",
    contact_us: "Contact Us",
    contact_us_detail: "Have a question or issue? Contact us! We're here to help!",
    email_phone_input_detail:
      "We respect your privacy. We will not share your information and will only contact you about your account.",
    welcome: `<p class="text-2xl">Welcome!<br><span class="text-xl">👋👋👋👋</span></p>

<p>I'm Taalia, your host & {{targetLanguage}} coach.</p>

<p>With a quick text chat we can determine your <strong>current level</strong> and I'll generate a <strong>detailed report</strong> on your fluency.</p>

<p>Unlock the FREE assessment in a few quick steps -- first, <em><strong>what should I call you?</strong></em></p>`,
    lets_do_it: "Let's do it",
    select: "Select",
    more_activities_soon: "More activities coming soon!",
    scoring_report: "Building your report...",
    registered_office:
      "Vondelbaan B.V. Registered office: 1017 BW Amsterdam, The Netherlands",
    get_app_end_of_report: "Do more activities and track your progress in the app.",
    view_report: "View Report",
    view_full_report_in_app: "See the full report for FREE in the app...",
    open_in_browser: "Open in Browser",
    open_in_browser_detail: `<p>It looks like you're using an in-app browser. For the best experience, please open this page in your phone's default browser.</p><p>Tap the <strong>share icon</strong> and choose <strong>&quot;Open in Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Or copy and paste this URL:",
    taking_longer_than_expected:
      "This is taking longer than expected. While waiting why not install the Taalia app :)  Your activity list and scores are available there too.",
  },
  TR: {
    english: "İngilizce",
    turkish: "Türkçe",
    dutch: "Felemenkçe",
    german: "Almanca",
    spanish: "İspanyolca",
    italian: "İtalyanca",
    french: "Fransızca",
    portuguese: "Portekizce",
    hindi: "Hintçe",
    arabic: "Arapça",
    ukrainian: "Ukraynaca",
    polish: "Lehçe",
    submit: "Gönder",
    default_input_placeholder: "Mesaj Taalia",
    input_placeholder_name: "Adınızı giriniz",
    taalia_home: "Taalia Ana Sayfa",
    about_taalia: "Taalia Hakkında",
    sign_in: "Giriş Yap",
    get_app: "Uygulama",
    copyright: "Copyright © 2025 Vondelbaan B.V. Tüm hakları saklıdır.",
    privacy_policy: "Gizlilik Politikası",
    terms_of_service: "Kullanım Koşulları",
    cookie_policy: "Çerez Politikası",
    close: "Kapat",
    unlock_your_free_assessment: "İlk ÜCRETSİZ değerlendirmenizi açın",
    contact_us: "Bize Ulaşın",
    contact_us_detail: "Bir sorunuz mu var? Yardımcı olmak için buradayız!",
    email_phone_input_detail:
      "Gizliliğinize saygı duyuyoruz. Bilgilerinizi paylaşmayacağız ve yalnızca hesabınızla ilgili olarak sizinle iletişim kuracağız.",
    welcome: `<p class="text-2xl">Hoş geldiniz!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Ben Taalia, ev sahibiniz ve {{targetLanguage}} koçunuz.</p>

<p>Kısa bir metin sohbetiyle <strong>mevcut seviyenizi</strong> belirleyeceğiz ve size <strong>akıcılığınız hakkında detaylı bir rapor</strong> sunacağım.</p>

<p>ÜCRETSİZ değerlendirmenizi birkaç hızlı adımda açın -- öncelikle, <em><strong>size nasıl hitap etmeliyim?</strong></em></p>`,
    lets_do_it: "Hadi başlayalım",
    select: "Seç",
    more_activities_soon: "Daha fazla aktivite yakında!",
    scoring_report: "Raporunuzu oluşturuyoruz...",
    registered_office: "Vondelbaan B.V. Kayıtlı ofis: 1017 BW Amsterdam, Hollanda",
    email_at: "E-posta",
    phone_hash: "Mobil",
    input_placeholder_email: "E-posta adresi",
    input_placeholder_phone: "Cep telefonu numarası",
    get_app_end_of_report:
      "Uygulamada daha fazla aktivite yapın ve ilerlemenizi takip edin.",
    view_report: "Raporu Görüntüle",
    do_more_with_taalia: "Taalia ile daha fazlasını yapın",
    view_full_report_in_app: "Taalia uygulamasında tam raporu ÜCRETSİZ görün...",
    install_taalia: "Taalia'yı Yükle",
    why_install: "Daha fazla aktivite yapın ve ilerlemenizi takip edin.",
    open_in_browser: "Tarayıcıda Aç",
    open_in_browser_detail: `<p>Görünüşe göre uygulama içi bir tarayıcı kullanıyorsunuz. En iyi deneyim için, lütfen bu sayfayı telefonunuzun varsayılan tarayıcısında açın.</p><p><strong>Paylaş simgesine</strong> dokunun ve <strong>&quot;Chrome/Safari'de Aç&quot;</strong> seçeneğini seçin.</p>`,
    or_copy_and_paste_url: "Veya bu URL'yi kopyalayıp yapıştırın:",
    taking_longer_than_expected:
      "Bu beklenenden daha uzun sürüyor. Beklerken neden Taalia uygulamasını yüklemeyesiniz :)  Aktivite listeniz ve puanlarınız da orada mevcut.",
  },
  NL: {
    english: "Engels",
    turkish: "Turks",
    dutch: "Nederlands",
    german: "Duits",
    spanish: "Spaans",
    italian: "Italiaans",
    french: "Frans",
    portuguese: "Portugees",
    hindi: "Hindi",
    arabic: "Arabisch",
    ukrainian: "Oekraïens",
    polish: "Pools",
    submit: "Verstuur",
    default_input_placeholder: "Bericht Taalia",
    input_placeholder_name: "Je naam",
    taalia_home: "Taalia Homepage",
    about_taalia: "Over Taalia",
    sign_in: "Inloggen",
    get_app: "App",
    copyright: "Copyright © 2025 Vondelbaan B.V. Alle rechten voorbehouden.",
    privacy_policy: "Privacybeleid",
    terms_of_service: "Gebruiksvoorwaarden",
    cookie_policy: "Cookiebeleid",
    close: "Sluiten",
    unlock_your_free_assessment: "Ontgrendel je eerste GRATIS beoordeling",
    contact_us: "Contacteer ons",
    contact_us_detail:
      "Heb je een vraag of probleem? Neem contact met ons op! We staan voor je klaar!",
    email_phone_input_detail:
      "Wij respecteren uw privacy. Wij zullen uw gegevens niet delen en alleen contact met u opnemen over uw account.",
    welcome: `<p class="text-2xl">Welkom!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Ik ben Taalia, je gastvrouw en {{targetLanguage}} coach.</p>

<p>Met een kort tekstgesprek bepalen we <strong>je huidige niveau</strong> en geef ik je een <strong>gedetailleerd rapport</strong> over je taalvaardigheid.</p>

<p>Ontgrendel je GRATIS beoordeling in een paar snelle stappen -- eerst, <em><strong>hoe mag ik je noemen?</strong></em></p>`,
    lets_do_it: "Laten we beginnen",
    select: "Selecteer",
    more_activities_soon: "Meer activiteiten komen binnenkort!",
    scoring_report: "Rapport wordt gemaakt...",
    registered_office: "Vondelbaan B.V. Kantooradres: 1017 BW Amsterdam, Nederland",
    email_at: "E-mail",
    phone_hash: "Mobiel",
    input_placeholder_email: "E-mailadres",
    input_placeholder_phone: "Mobiel nummer",
    get_app_end_of_report: "Doe meer activiteiten en volg je voortgang in de app.",
    view_report: "Rapport Bekijken",
    do_more_with_taalia: "Doe meer met Taalia",
    view_full_report_in_app: "Krijg het volledige rapport GRATIS in de app...",
    install_taalia: "Taalia Installeren",
    why_install: "Doe meer activiteiten en volg je voortgang.",
    open_in_browser: "Openen in Browser",
    open_in_browser_detail: `<p>Het lijkt erop dat u een in-app browser gebruikt. Voor de beste ervaring, open deze pagina in de standaard browser van uw telefoon.</p><p>Tik op het <strong>deel-icoon</strong> en kies <strong>&quot;Openen in Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Of kopieer en plak deze URL:",
    taking_longer_than_expected:
      "Dit duurt langer dan verwacht. Waarom installeer je de Taalia-app niet terwijl je wacht :)  Je activiteitenlijst en scores zijn daar ook beschikbaar.",
  },
  DE: {
    english: "Englisch",
    turkish: "Türkisch",
    dutch: "Niederländisch",
    german: "Deutsch",
    spanish: "Spanisch",
    italian: "Italienisch",
    french: "Französisch",
    portuguese: "Portugiesisch",
    hindi: "Hindi",
    arabic: "Arabisch",
    ukrainian: "Ukrainisch",
    polish: "Polnisch",
    submit: "Senden",
    default_input_placeholder: "Nachricht an Taalia",
    input_placeholder_name: "Ihr Name",
    taalia_home: "Taalia Homepage",
    about_taalia: "Über Taalia",
    sign_in: "Anmelden",
    get_app: "App",
    copyright: "Copyright © 2025 Vondelbaan B.V. Alle Rechte vorbehalten.",
    privacy_policy: "Datenschutzbestimmungen",
    terms_of_service: "Nutzungsbedingungen",
    cookie_policy: "Cookie-Richtlinie",
    close: "Schließen",
    unlock_your_free_assessment: "Schalte deine erste KOSTENLOSE Bewertung frei",
    contact_us: "Kontaktieren Sie uns",
    contact_us_detail:
      "Haben Sie eine Frage oder ein Problem? Kontaktieren Sie uns! Wir sind hier, um Ihnen zu helfen.",
    email_phone_input_detail:
      "Wir respektieren Ihre Privatsphäre. Wir werden Ihre Daten nicht weitergeben und Sie nur bezüglich Ihres Kontos kontaktieren.",
    welcome: `<p class="text-2xl">Willkommen!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Ich bin Taalia, deine Gastgeberin und {{targetLanguage}}-Coach.</p>

<p>Mit einem kurzen Textchat bestimmen wir <strong>dein aktuelles Niveau</strong> und ich gebe dir einen <strong>detaillierten Bericht</strong> über deine Sprachkenntnisse.</p>

<p>Schalte deine KOSTENLOSE Bewertung in wenigen schnellen Schritten frei -- zuerst, <em><strong>wie soll ich dich nennen?</strong></em></p>`,
    lets_do_it: "Lassen Sie uns anfangen",
    select: "Auswählen",
    more_activities_soon: "Weitere Aktivitäten kommen bald!",
    scoring_report: "Bericht wird erstellt...",
    registered_office:
      "Vondelbaan B.V. Eingetragener Sitz: 1017 BW Amsterdam, Niederlande",
    email_at: "E-Mail",
    phone_hash: "Mobil",
    input_placeholder_email: "E-Mail-Adresse",
    input_placeholder_phone: "Handynummer",
    get_app_end_of_report:
      "Machen Sie mehr Aktivitäten und verfolgen Sie Ihren Fortschritt in der App.",
    view_report: "Bericht Anzeigen",
    do_more_with_taalia: "Mehr mit Taalia machen",
    view_full_report_in_app:
      "Holen Sie sich den vollständigen Bericht KOSTENLOS in der App...",
    install_taalia: "Taalia Installieren",
    why_install: "Machen Sie mehr Aktivitäten und verfolgen Sie Ihren Fortschritt.",
    open_in_browser: "Im Browser öffnen",
    open_in_browser_detail: `<p>Es scheint, dass Sie einen In-App-Browser verwenden. Für die beste Erfahrung öffnen Sie diese Seite bitte im Standard-Browser Ihres Telefons.</p><p>Tippen Sie auf das <strong>Teilen-Symbol</strong> und wählen Sie <strong>&quot;In Chrome/Safari öffnen&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Oder kopieren und fügen Sie diese URL ein:",
    taking_longer_than_expected:
      "Dies dauert länger als erwartet. Während Sie warten, warum installieren Sie nicht die Taalia-App :)  Ihre Aktivitätsliste und Punktzahlen sind dort ebenfalls verfügbar.",
  },
  IT: {
    english: "Inglese",
    turkish: "Turco",
    dutch: "Olandese",
    german: "Tedesco",
    spanish: "Spagnolo",
    italian: "Italiano",
    french: "Francese",
    portuguese: "Portoghese",
    hindi: "Hindi",
    arabic: "Arabo",
    ukrainian: "Ucraino",
    polish: "Polacco",
    submit: "Invia",
    default_input_placeholder: "Messaggio a Taalia",
    input_placeholder_name: "Il tuo nome",
    taalia_home: "Pagina iniziale di Taalia",
    about_taalia: "Informazioni su Taalia",
    sign_in: "Accedi",
    get_app: "App",
    copyright: "Copyright © 2025 Vondelbaan B.V. Tutti i diritti riservati.",
    privacy_policy: "Informativa sulla privacy",
    terms_of_service: "Condizioni di servizio",
    cookie_policy: "Politica sui cookie",
    close: "Chiudi",
    unlock_your_free_assessment: "Sblocca la tua prima valutazione GRATUITA",
    contact_us: "Contattaci",
    contact_us_detail:
      "Hai una domanda o un problema? Contattaci! Siamo qui per aiutarti.",
    email_phone_input_detail:
      "Rispettiamo la tua privacy. Non condivideremo le tue informazioni e ti contatteremo solo per questioni relative al tuo account.",
    welcome: `<p class="text-2xl">Benvenuto!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Sono Taalia, la tua ospite e coach di {{targetLanguage}}.</p>

<p>Con una breve chat di testo determineremo <strong>il tuo livello attuale</strong> e ti fornirò un <strong>rapporto dettagliato</strong> sulla tua fluidità.</p>

<p>Sblocca la tua valutazione GRATUITA in pochi rapidi passaggi -- prima, <em><strong>come posso chiamarti?</strong></em></p>`,
    lets_do_it: "Iniziamo",
    select: "Seleziona",
    more_activities_soon: "Presto altre attività!",
    scoring_report: "Creazione del rapporto...",
    registered_office: "Vondelbaan B.V. Sede legale: 1017 BW Amsterdam, Paesi Bassi",
    email_at: "Email",
    phone_hash: "Cellulare",
    input_placeholder_email: "Indirizzo email",
    input_placeholder_phone: "Numero di cellulare",
    get_app_end_of_report:
      "Fai più attività e tieni traccia dei tuoi progressi nell'app.",
    view_report: "Visualizza Rapporto",
    do_more_with_taalia: "Fai di più con Taalia",
    view_full_report_in_app: "Ottieni il rapporto completo GRATUITAMENTE nell'app...",
    install_taalia: "Installa Taalia",
    why_install: "Fai più attività e tieni traccia dei tuoi progressi.",
    open_in_browser: "Apri nel Browser",
    open_in_browser_detail: `<p>Sembra che tu stia utilizzando un browser in-app. Per la migliore esperienza, apri questa pagina nel browser predefinito del tuo telefono.</p><p>Tocca l'<strong>icona di condivisione</strong> e scegli <strong>&quot;Apri in Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Oppure copia e incolla questo URL:",
    taking_longer_than_expected:
      "Sta impiegando più tempo del previsto. Mentre aspetti, perché non installare l'app Taalia :)  Anche la tua lista di attività e i punteggi sono disponibili lì.",
  },
  FR: {
    english: "Anglais",
    turkish: "Turc",
    dutch: "Néerlandais",
    german: "Allemand",
    spanish: "Espagnol",
    italian: "Italien",
    french: "Français",
    portuguese: "Portugais",
    hindi: "Hindi",
    arabic: "Arabe",
    ukrainian: "Ukrainien",
    polish: "Polonais",
    submit: "Envoyer",
    default_input_placeholder: "Message à Taalia",
    input_placeholder_name: "Votre nom",
    taalia_home: "Page d'accueil de Taalia",
    about_taalia: "À propos de Taalia",
    sign_in: "Connexion",
    get_app: "App",
    copyright: "Copyright © 2025 Vondelbaan B.V. Tous droits réservés.",
    privacy_policy: "Politique de confidentialité",
    terms_of_service: "Conditions d'utilisation",
    cookie_policy: "Politique de cookies",
    close: "Fermer",
    unlock_your_free_assessment: "Débloquez votre première évaluation GRATUITE",
    contact_us: "Contactez-nous",
    contact_us_detail:
      "Une question ou un souci ? Contactez-nous ! Nous sommes là pour vous aider.",
    email_phone_input_detail:
      "Nous respectons votre vie privée. Nous ne partagerons pas vos informations et vous contacterons uniquement au sujet de votre compte.",
    welcome: `<p class="text-2xl">Bienvenue!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Je suis Taalia, votre hôte et coach en {{targetLanguage}}.</p>

<p>Grâce à une brève discussion par texte, nous déterminerons <strong>votre niveau actuel</strong> et je vous fournirai un <strong>rapport détaillé</strong> sur votre fluidité.</p>

<p>Débloquez votre évaluation GRATUITE en quelques étapes rapides -- d'abord, <em><strong>comment dois-je vous appeler ?</strong></em></p>`,
    lets_do_it: "Commencer",
    select: "Sélectionner",
    more_activities_soon: "Plus d'activités à venir bientôt !",
    scoring_report: "Rapport en cours de construction...",
    registered_office: "Vondelbaan B.V. Siège social: 1017 BW Amsterdam, Pays-Bas",
    email_at: "Email",
    phone_hash: "Mobile",
    input_placeholder_email: "Adresse e-mail",
    input_placeholder_phone: "Numéro de mobile",
    get_app_end_of_report:
      "Faites plus d'activités et suivez vos progrès dans l'application.",
    view_report: "Voir le Rapport",
    do_more_with_taalia: "Faites plus avec Taalia",
    view_full_report_in_app:
      "Obtenez le rapport complet GRATUITEMENT dans l'application...",
    install_taalia: "Installer Taalia",
    why_install: "Faites plus d'activités et suivez vos progrès.",
    open_in_browser: "Ouvrir dans le Navigateur",
    open_in_browser_detail: `<p>Il semble que vous utilisez un navigateur intégré à l'application. Pour une meilleure expérience, veuillez ouvrir cette page dans le navigateur par défaut de votre téléphone.</p><p>Appuyez sur l'<strong>icône de partage</strong> et choisissez <strong>&quot;Ouvrir dans Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Ou copiez et collez cette URL :",
    taking_longer_than_expected:
      "Cela prend plus de temps que prévu. En attendant, pourquoi ne pas installer l'application Taalia :)  Votre liste d'activités et vos scores y sont également disponibles.",
  },
  PT: {
    english: "Inglês",
    turkish: "Turco",
    dutch: "Holandês",
    german: "Alemão",
    spanish: "Espanhol",
    italian: "Italiano",
    french: "Francês",
    portuguese: "Português",
    hindi: "Hindi",
    arabic: "Árabe",
    ukrainian: "Ucraniano",
    polish: "Polonês",
    submit: "Enviar",
    default_input_placeholder: "Digite uma mensagem para Taalia",
    input_placeholder_name: "Seu nome",
    taalia_home: "Página inicial de Taalia",
    about_taalia: "Sobre Taalia",
    sign_in: "Entrar",
    get_app: "App",
    copyright: "Copyright © 2025 Vondelbaan B.V. Todos os direitos reservados.",
    privacy_policy: "Política de privacidade",
    terms_of_service: "Termos de serviço",
    cookie_policy: "Política de cookies",
    close: "Fechar",
    unlock_your_free_assessment: "Desbloqueie sua primeira avaliação GRATUITA",
    contact_us: "Fale conosco",
    contact_us_detail:
      "Tem alguma dúvida ou problema? Fale conosco! Estamos aqui para ajudar.",
    email_phone_input_detail:
      "Respeitamos sua privacidade. Não compartilharemos suas informações e entraremos em contato apenas sobre sua conta.",
    welcome: `<p class="text-2xl">Bem-vindo!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Sou Taalia, sua anfitriã e treinadora de {{targetLanguage}}.</p>

<p>Com uma breve conversa por texto, determinaremos <strong>seu nível atual</strong> e eu lhe fornecerei um <strong>relatório detalhado</strong> sobre sua fluência.</p>

<p>Desbloqueie sua avaliação GRATUITA em alguns passos rápidos -- primeiro, <em><strong>como devo chamá-lo(a)?</strong></em></p>`,
    lets_do_it: "Começar",
    select: "Selecionar",
    more_activities_soon: "Mais atividades em breve!",
    scoring_report: "Relatório em construção...",
    registered_office:
      "Vondelbaan B.V. Escritório registrado: 1017 BW Ámsterdam, Países Bajos",
    email_at: "Email",
    phone_hash: "Celular",
    input_placeholder_email: "Endereço de e-mail",
    input_placeholder_phone: "Número de celular",
    get_app_end_of_report:
      "Faça mais atividades e acompanhe seu progresso no aplicativo.",
    view_report: "Ver Relatório",
    do_more_with_taalia: "Faça mais com Taalia",
    view_full_report_in_app:
      "Obtenha o relatório completo GRATUITAMENTE no aplicativo...",
    install_taalia: "Instalar Taalia",
    why_install: "Faça mais atividades e acompanhe seu progresso.",
    open_in_browser: "Abrir no Navegador",
    open_in_browser_detail: `<p>Parece que você está usando um navegador dentro do aplicativo. Para a melhor experiência, abra esta página no navegador padrão do seu telefone.</p><p>Toque no <strong>ícone de compartilhamento</strong> e escolha <strong>&quot;Abrir no Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Ou copie e cole este URL:",
    taking_longer_than_expected:
      "Isso está demorando mais do que o esperado. Enquanto espera, que tal instalar o aplicativo Taalia :)  Sua lista de atividades e pontuações também estão disponíveis lá.",
  },
  HI: {
    english: "अंग्रे़ी",
    turkish: "तुर्की",
    dutch: "डच",
    german: "जर्मन",
    spanish: "स्पेनी",
    italian: "इतालवी",
    french: "फ़्रेंच",
    portuguese: "पुर्तगाली",
    hindi: "हिंदी",
    arabic: "अरबी",
    ukrainian: "यूक्रेनी",
    polish: "पोलिश",
    submit: "भेजें",
    default_input_placeholder: "तालिया को संदेश भेजें",
    input_placeholder_name: "आपका नाम",
    taalia_home: "तालिया मुखपृष्ठ",
    about_taalia: "तालिया के बारे में",
    sign_in: "साइन इन करें",
    get_app: "ऐप",
    copyright: "कॉपीराइट © 2025 Vondelbaan B.V. सभी अधिकार सुरक्षित हैं।",
    privacy_policy: "गोपनीयता नीति",
    terms_of_service: "सेवा की शर्तें",
    cookie_policy: "कुकी नीति",
    close: "बंद करें",
    unlock_your_free_assessment: "अपना पहला मुफ्त मूल्यांकन शुरू करें",
    contact_us: "संपर्क करें",
    contact_us_detail:
      "क्या आपके पास कोई प्रश्न या समस्या है? हमसे संपर्क करें! हम आपकी सहायता के लिए यहाँ हैं।",
    email_phone_input_detail:
      "हम आपकी गोपनीयता का सम्मान करते हैं। हम आपकी जानकारी साझा नहीं करेंगे और केवल आपके खाते के बारे में आपसे संपर्क करेंगे।",
    welcome: `<p class="text-2xl">स्वागत है!<br><span class="text-xl">👋👋👋👋</span></p>

<p>मैं तालीया हूँ, आपकी मेज़बान और {{targetLanguage}} कोच।</p>

<p>एक त्वरित पाठ चैट के माध्यम से, हम <strong>आपका वर्तमान स्तर</strong> निर्धारित करेंगे और मैं आपको <strong>आपकी धाराप्रवाहता पर विस्तृत रिपोर्ट</strong> दूंगी।</p>

<p>अपना मुफ्त मूल्यांकन कुछ त्वरित चरणों में अनलॉक करें -- सबसे पहले, <em><strong>मैं आपको क्या कहूं?</strong></em></p>`,
    lets_do_it: "चलो शुरू करें",
    select: "चुनें",
    more_activities_soon: "जल्द ही और गतिविधियां आ रही हैं!",
    scoring_report: "रिपोर्ट बनाने में...",
    registered_office: "Vondelbaan B.V. पंजीकृत कार्यालय: 1017 BW एम्स्टर्डम, नीदरलैंड्स",
    email_at: "ईमेल",
    phone_hash: "मोबाइल",
    input_placeholder_email: "ईमेल पता",
    input_placeholder_phone: "मोबाइल नंबर",
    get_app_end_of_report: "ऐप में अधिक गतिविधियाँ करें और अपनी प्रगति को ट्रैक करें।",
    view_report: "रिपोर्ट देखें",
    do_more_with_taalia: "तालिया के साथ और अधिक करें",
    view_full_report_in_app: "ऐप में पूरी रिपोर्ट मुफ्त में देखें...",
    install_taalia: "तालिया इंस्टॉल करें",
    why_install: "और गतिविधियाँ करें और अपनी प्रगति को ट्रैक करें।",
    open_in_browser: "ब्राउ़ज़र में खोलें",
    open_in_browser_detail: `<p>ऐसा लगता है कि आप इन-ऐप ब्राउ़ज़र का उपयोग कर रहे हैं। सर्वोत्तम अनुभव के लिए, कृपया इस पृष्ठ को अपने फ़ोन के डिफ़ॉल्ट ब्राउ़ज़र में खोलें।</p><p><strong>शेयर आइकन</strong> पर टैप करें और <strong>&quot;Chrome/Safari में खोलें&quot;</strong> चुनें।</p>`,
    or_copy_and_paste_url: "या इस URL को कॉपी और पेस्ट करें:",
    taking_longer_than_expected:
      "यह अपेक्षा से अधिक समय ले रहा है। प्रतीक्षा करते समय क्यों न तालिया ऐप इंस्टॉल करें :)  आपकी गतिविधि सूची और स्कोर भी वहां उपलब्ध हैं।",
  },
  AR: {
    english: "الإنجليزية",
    turkish: "التركية",
    dutch: "هولندي",
    german: "الألمانية",
    spanish: "الإسبانية",
    italian: "الإيطالية",
    french: "الفرنسية",
    portuguese: "البرتغالية",
    hindi: "هندي",
    arabic: "عربي",
    ukrainian: "الأوكرانية",
    polish: "البولندية",
    submit: "إرسال",
    default_input_placeholder: "رسالة لتاليا",
    input_placeholder_name: "اسمك",
    taalia_home: "الرئيسية لتاليا",
    about_taalia: "عن تاليا",
    sign_in: "تسجيل الدخول",
    get_app: "التطبيق",
    copyright: "كوبيرايت © 2025 Vondelbaan B.V. كل الحقوق محفوظة.",
    privacy_policy: "سياسة الخصوصية",
    terms_of_service: "الشروط والأحكام",
    cookie_policy: "سياسة الكوكيز",
    close: "إغلاق",
    unlock_your_free_assessment: "افتح تقييمك الأول المجاني",
    contact_us: "تواصل معنا",
    contact_us_detail: "هل لديك سؤال أو مشكلة؟ اتصل بنا! نحن هنا لمساعدتك!",
    email_phone_input_detail:
      "نحن نحترم خصوصيتك. لن نشارك معلوماتك وسنتواصل معك فقط بخصوص حسابك.",
    welcome: `<p class="text-2xl">مرحبًا!<br><span class="text-xl">👋👋👋👋</span></p>

<p>أنا تاليا، مضيفتك ومدربتك في {{targetLanguage}}.</p>

<p>من خلال محادثة نصية سريعة، سنحدد <strong>مستواك الحالي</strong> وسأقدم لك <strong>تقريرًا مفصلًا</strong> عن طلاقتك اللغوية.</p>

<p>افتح تقييمك المجاني في بضع خطوات سريعة -- أولاً، <em><strong>ما الاسم الذي يجب أن أناديك به؟</strong></em></p>`,
    lets_do_it: "ابدأ",
    select: "اختر",
    more_activities_soon: "المزيد من الأنشطة قريباً!",
    scoring_report: "يتم إنشاء التقرير...",
    registered_office: "Vondelbaan B.V. المكتب المسجل: 1017 BW أمستردام، هولندا",
    email_at: "البريد",
    phone_hash: "المحمول",
    input_placeholder_email: "البريد الإلكتروني",
    input_placeholder_phone: "رقم الجوال",
    get_app_end_of_report: "قم بالمزيد من الأنشطة وتتبع تقدمك في التطبيق.",
    view_report: "عرض التقرير",
    do_more_with_taalia: "افعل المزيد مع تاليا",
    view_full_report_in_app: "احصل على التقرير الكامل مجانًا في التطبيق...",
    install_taalia: "تثبيت تاليا",
    why_install: "قم بالمزيد من الأنشطة وتتبع تقدمك.",
    open_in_browser: "فتح في المتصفح",
    open_in_browser_detail: `<p>يبدو أنك تستخدم متصفحًا داخل التطبيق. للحصول على أفضل تجربة، يرجى فتح هذه الصفحة في متصفح هاتفك الافتراضي.</p><p>اضغط على <strong>رمز المشاركة</strong> واختر <strong>&quot;فتح في Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "أو انسخ والصق هذا الرابط:",
    taking_longer_than_expected:
      "هذا يستغرق وقتًا أطول من المتوقع. أثناء الانتظار، لماذا لا تقوم بتثبيت تطبيق تاليا :)  قائمة أنشطتك ودرجاتك متاحة هناك أيضًا.",
  },
  PL: {
    english: "Angielski",
    turkish: "Turecki",
    dutch: "Holenderski",
    german: "Niemiecki",
    spanish: "Hiszpański",
    italian: "Włoski",
    french: "Francuski",
    portuguese: "Portugalski",
    hindi: "Hinduski",
    arabic: "Arabski",
    ukrainian: "Ukraiński",
    polish: "Polski",
    submit: "Wyślij",
    default_input_placeholder: "Wiadomość do Taalia",
    input_placeholder_name: "Twoje imię",
    taalia_home: "Strona główna Taalia",
    about_taalia: "O Taalia",
    sign_in: "Zaloguj się",
    get_app: "Aplikacja",
    copyright: "Copyright © 2025 Vondelbaan B.V. Wszelkie prawa zastrzeżone.",
    privacy_policy: "Polityka prywatności",
    terms_of_service: "Warunki korzystania z usługi",
    cookie_policy: "Polityka plików cookie",
    close: "Zamknij",
    unlock_your_free_assessment: "Odblokuj swoją pierwszą BEZPŁATNĄ ocenę",
    contact_us: "Skontaktuj się z nami",
    contact_us_detail:
      "Masz pytanie lub problem? Skontaktuj się z nami! Jesteśmy tutaj, aby pomóc.",
    email_phone_input_detail:
      "Szanujemy Twoją prywatność. Nie udostępnimy Twoich informacji i będziemy kontaktować się z Tobą tylko w sprawie Twojego konta.",
    welcome: `<p class="text-2xl">Witamy!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Jestem Taalia, twoja gospodyni i trenerka {{targetLanguage}}.</p>

<p>Za pomocą krótkiej rozmowy tekstowej określimy <strong>twój obecny poziom</strong> i przedstawię ci <strong>szczegółowy raport</strong> o twojej płynności.</p>

<p>Odblokuj swoją BEZPŁATNĄ ocenę w kilku szybkich krokach -- najpierw, <em><strong>jak mam się do Ciebie zwracać?</strong></em></p>`,
    lets_do_it: "Zróbmy to",
    select: "Wybierz",
    more_activities_soon: "Wkrótce więcej aktywności!",
    scoring_report: "Raport jest tworzony...",
    registered_office: "Vondelbaan B.V. Siedziba: 1017 BW Amsterdam, Holandia",
    email_at: "Email",
    phone_hash: "Mobilny",
    input_placeholder_email: "Adres e-mail",
    input_placeholder_phone: "Numer telefonu komórkowego",
    get_app_end_of_report: "Wykonuj więcej aktywności i śledź swoje postępy w aplikacji.",
    view_report: "Zobacz Raport",
    do_more_with_taalia: "Zrób więcej z Taalia",
    view_full_report_in_app: "Pobierz pełny raport ZA DARMO w aplikacji...",
    install_taalia: "Zainstaluj Taalia",
    why_install: "Wykonuj więcej aktywności i śledź swoje postępy.",
    open_in_browser: "Otwórz w Przeglądarce",
    open_in_browser_detail: `<p>Wygląda na to, że używasz przeglądarki w aplikacji. Aby uzyskać najlepsze wrażenia, otwórz tę stronę w domyślnej przeglądarce telefonu.</p><p>Stuknij <strong>ikonę udostępniania</strong> i wybierz <strong>&quot;Otwórz w Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Lub skopiuj i wklej ten adres URL:",
    taking_longer_than_expected:
      "To trwa dłużej niż oczekiwano. Czekając, dlaczego nie zainstalować aplikacji Taalia :)  Twoja lista aktywności i wyniki są tam również dostępne.",
  },
  UK: {
    english: "Англійська",
    turkish: "Турецька",
    dutch: "Голландська",
    german: "Німецька",
    spanish: "Іспанська",
    italian: "Італійська",
    french: "Французька",
    portuguese: "Португальська",
    hindi: "хінді",
    arabic: "Арабська",
    ukrainian: "Українська",
    polish: "Польська",
    submit: "Відправити",
    default_input_placeholder: "Повідомлення до Taalia",
    input_placeholder_name: "Ваше ім'я",
    taalia_home: "Головна сторінка Taalia",
    about_taalia: "Про Taalia",
    sign_in: "Увійти",
    get_app: "Додаток",
    copyright: "Копірайт © 2025 Vondelbaan B.V. Всі права захищені.",
    privacy_policy: "Політика конфіденційності",
    terms_of_service: "Умови використання",
    cookie_policy: "Політика файлів cookie",
    close: "Закрити",
    unlock_your_free_assessment: "Розблокуйте вашу першу БЕЗКОШТОВНУ оцінку",
    contact_us: "Зв'язатися з нами",
    contact_us_detail:
      "Маєте запитання або проблему? Зв'яжіться з нами! Ми тут, щоб допомогти!",
    email_phone_input_detail:
      "Ми поважаємо вашу конфіденційність. Ми не передаватимемо вашу інформацію та зв'язуватимемося з вами лише щодо вашого облікового запису.",
    welcome: `<p class="text-2xl">Ласкаво просимо!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Я Таалія, ваша господиня та тренер з {{targetLanguage}}.</p>

<p>За допомогою короткого текстового чату ми визначимо <strong>ваш поточний рівень</strong> і я надам вам <strong>детальний звіт</strong> про вашу плавність мови.</p>

<p>Розблокуйте вашу БЕЗКОШТОВНУ оцінку за кілька швидких кроків -- спочатку, <em><strong>як мені до вас звертатися?</strong></em></p>`,
    lets_do_it: "Зробимо це",
    select: "Виберіть",
    more_activities_soon: "Більше активностей незабаром!",
    scoring_report: "Звіт будується...",
    registered_office:
      "Vondelbaan B.V. Зареєстрований офіс: 1017 BW Амстердам, Нідерланди",
    email_at: "Email",
    phone_hash: "Мобільний",
    input_placeholder_email: "Електронна адреса",
    input_placeholder_phone: "Номер мобільного",
    get_app_end_of_report:
      "Виконуйте більше завдань і відстежуйте свій прогрес у додатку.",
    view_report: "Переглянути Звіт",
    do_more_with_taalia: "Зробіть більше з Taalia",
    view_full_report_in_app: "Отримайте повний звіт БЕЗКОШТОВНО в додатку...",
    install_taalia: "Встановити Taalia",
    why_install: "Виконуйте більше завдань і відстежуйте свій прогрес.",
    open_in_browser: "Відкрити в Браузері",
    open_in_browser_detail: `<p>Схоже, ви використовуєте браузер у додатку. Для найкращого досвіту, будь ласка, відкрийте цю сторінку у стандартному браузері вашого телефону.</p><p>Натисніть <strong>значок спільного доступу</strong> і виберіть <strong>&quot;Відкрити в Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "Або скопіюйте та вставте цю URL-адресу:",
    taking_longer_than_expected:
      "Це займає більше часу, ніж очікувалося. Поки ви чекаєте, чому б не встановити додаток Taalia :)   Ваш список активностей та бали також доступні там.",
  },
  ES: {
    english: "Inglés",
    turkish: "Turco",
    dutch: "Neerlandés",
    german: "Alemán",
    spanish: "Español",
    italian: "Italiano",
    french: "Francés",
    portuguese: "Portugués",
    hindi: "Hindi",
    arabic: "Árabe",
    ukrainian: "Ucraniano",
    polish: "Polaco",
    submit: "Enviar",
    default_input_placeholder: "Mensaje para Taalia",
    input_placeholder_name: "Tu nombre",
    taalia_home: "Página de inicio de Taalia",
    about_taalia: "Acerca de Taalia",
    sign_in: "Iniciar sesión",
    get_app: "App",
    copyright: "Copyright © 2025 Vondelbaan B.V. Todos los derechos reservados.",
    privacy_policy: "Política de privacidad",
    terms_of_service: "Términos del servicio",
    cookie_policy: "Política de cookies",
    close: "Cerrar",
    unlock_your_free_assessment: "Desbloquea tu primera evaluación GRATUITA",
    contact_us: "Contáctanos",
    contact_us_detail:
      "¿Tienes una pregunta o problema? ¡Contáctanos! Estamos aquí para ayudarte.",
    email_phone_input_detail:
      "Respetamos tu privacidad. No compartiremos tu información y solo te contactaremos sobre tu cuenta.",
    welcome: `<p class="text-2xl">¡Bienvenido!<br><span class="text-xl">👋👋👋👋</span></p>

<p>Soy Taalia, tu anfitriona y entrenadora de {{targetLanguage}}.</p>

<p>Con una breve conversación de texto, determinaremos <strong>tu nivel actual</strong> y te proporcionaré un <strong>informe detallado</strong> sobre tu fluidez.</p>

<p>Desbloquea tu evaluación GRATUITA en unos pocos pasos rápidos -- primero, <em><strong>¿cómo debo llamarte?</strong></em></p>`,
    lets_do_it: "Vamos allá",
    select: "Seleccionar",
    more_activities_soon: "¡Más actividades próximamente!",
    scoring_report: "Informe en construcción...",
    registered_office:
      "Vondelbaan B.V. Oficina registrada: 1017 BW Ámsterdam, Países Bajos",
    email_at: "Email",
    phone_hash: "Móvil",
    input_placeholder_email: "Correo electrónico",
    input_placeholder_phone: "Número de móvil",
    get_app_end_of_report:
      "Realiza más actividades y sigue tu progreso en la aplicación.",
    view_report: "Ver Informe",
    do_more_with_taalia: "Haz más con Taalia",
    view_full_report_in_app: "Obtén el informe completo GRATIS en la aplicación...",
    install_taalia: "Instalar Taalia",
    why_install: "Realiza más actividades y sigue tu progreso.",
    open_in_browser: "Abrir en el Navegador",
    open_in_browser_detail: `<p>Parece que estás usando un navegador dentro de la aplicación. Para la mejor experiencia, abre esta página en el navegador predeterminado de tu teléfono.</p><p>Toca el <strong>icono de compartir</strong> y elige <strong>&quot;Abrir en Chrome/Safari&quot;</strong>.</p>`,
    or_copy_and_paste_url: "O copia y pega esta URL:",
    taking_longer_than_expected:
      "Esto está tomando más tiempo de lo esperado. Mientras esperas, ¿por qué no instalar la aplicación de Taalia? :)  Tu lista de actividades y puntuaciones también están disponibles allí.",
  },
};
